import React from 'react'
import SubNavbar from '../components/SubNavbar'
import Navbar from '../components/Navbar'
import PageHeading from './PageHeading';
import SectionProperties from './SectionProperties';
import FooterProperties from './FooterProperties';
import { CartProvider } from 'react-use-cart';

function AllProperties() {
  return (
    <CartProvider>
        <SubNavbar/>
        <Navbar/>
        <PageHeading/>
        <SectionProperties/>
        <FooterProperties/>
    </CartProvider>
  )
}

export default AllProperties;